import React, { PropTypes, Component } from 'react'
import {getPage} from '../../store/reducers';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

function withPage(WrappedComponent, options={}){
    class Page extends Component {

        componentWillMount() {
            if(!this.props.page){
                this.props._get_page({ page_id: this.props.match.params.page_id, options: { ...options, slug: options.slug || this.props.slug } })
            }
        }

        render() {
            return (
                <WrappedComponent {...this.props} />
            ) 
        }
    }
    return withRouter(connect( 
        (state, ownProps) =>{
            const id_slug = ownProps.slug 
            ? ownProps.slug
            : ( ownProps.match.params.page_id ? ownProps.match.params.page_id : null )
            return {
            page: id_slug ? state.app.pages[id_slug] : null
            }
        },
        dispatch => { 
            return { 
                _get_page: (payload) => { dispatch(getPage(payload)) } ,
            } 
        }
    )(Page));
}

export default withPage



// WEBPACK FOOTER //
// ./src/containers/withpage/index.js